/* Skeleton.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Hide, media, Show } from '@atlaskit/primitives/responsive';
import { HeaderSkeleton, Stripe } from '@atlassian/mpac-primitives';
import React from 'react';
import { Card } from './ProminentSectionInfo';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _5 = "@media (min-width:48rem){._19wgpxbi{gap:var(--ds-space-200,1pc)}}";
const _4 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulp1b66 _1e0c1txw _2lx21bp4 _otyrxy5q _19wgpxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
export const ProminentSectionInfoSkeleton = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Show, {
    above: "sm",
    children: /*#__PURE__*/_jsxs(Card, {
      children: [/*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Stripe, {
          width: "224px",
          borderRadius: "10px"
        }), /*#__PURE__*/_jsx(Stripe, {
          width: "194px",
          borderRadius: "10px"
        })]
      }), /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Stripe, {
          height: "14px"
        }), /*#__PURE__*/_jsx(Stripe, {
          height: "14px"
        }), /*#__PURE__*/_jsx(Stripe, {
          height: "14px",
          width: "182px"
        })]
      }), /*#__PURE__*/_jsx(Stripe, {
        width: "160px",
        height: "10px",
        borderRadius: "var(--ds-radius-small, 4px)"
      })]
    })
  }), /*#__PURE__*/_jsx(Hide, {
    above: "sm",
    children: /*#__PURE__*/_jsx(HeaderSkeleton, {})
  })]
});